import { createFileRoute } from "@tanstack/react-router";

import { requireSuperAdmin } from "@/features/auth/permissions/requireSuperAdmin";
import { DesignTypesPage } from "@/features/mbc-admin/design-types/DesignTypesPage";
import { usePageTitle } from "@/hooks/usePageTitle";

export const Route = createFileRoute("/_auth/_app-shell/admin/design-types/")({
  beforeLoad: ({ context }) => requireSuperAdmin(context),
  component: RouteComponent,
});

function RouteComponent() {
  usePageTitle("Design types");

  return <DesignTypesPage />;
}
